<template>
  <div
    class="question jblock is-vertical-center is-fullscreen"
    @click="swapState"
  >
    <h4 v-if="state === 'answer'">
      {{ question.answer }}
    </h4>
    <h4 v-else>
      {{ question.clue }}
    </h4>

    <div class="buttons is-centered" v-if="state === 'answer' && !passed">
      <a class="button is-success is-large is-rounded" @click.stop="markCorrect(true)">Correct</a>
      <a class="button is-danger is-large is-rounded" @click.stop="markCorrect(false)">Wrong</a>
    </div>
    <div class="buttons is-centered" v-if="state === 'answer' && passed">
      <a class="button is-light is-large is-rounded" @click.stop="pass">Continue</a>
    </div>
    <div class="buttons is-centered" v-if="state === 'clue' && !answered">
      <a class="button is-light is-large is-rounded" @click.stop="pass">Pass</a>
    </div>

    <h5 class="meta">
      {{ question.category.category }}<br/>
      ${{ question.value }}
    </h5>
  </div>
</template>

<script>
  import EventBus from '@/EventBus';

  export default {
    name: 'ActiveQuestion',
    props: {
      question: Object,
    },

    data() {
      return {
        state: 'clue',
        answered: false,
        correct: null,
        passed: false,
      };
    },

    created() {
      window.addEventListener('keyup', this.processKeys);
    },

    methods: {
      reset() {
        // since we're reusing the same ActiveQuestion instance, we have to reset state
        this.$set(this.question, 'state', 'answer');
        this.state = 'clue';
        this.answered = false;
        this.correct = null;
        this.passed = false;
      },

      swapState() {
        // track when Qs are revealed for tracking coryat
        if (!this.state) EventBus.$emit('revealed', this.question);

        this.state = this.state === 'clue' ? 'answer' : 'clue';
      },

      processKeys(evt) {
        if (
          this.state === 'answer' &&
          this.answered === false &&
          evt.key === 'Enter'
        ) {
          this.markCorrect(true);
        } else if (
          this.state === 'answer' &&
          this.answered === false &&
          evt.key === 'x'
        ) {
          this.markCorrect(false);
        } else if (
          this.state === 'clue' &&
          this.answered === false &&
          evt.key === ' '
        ) {
          this.pass();
        } else if (
          this.state === 'answer' &&
          this.passed &&
          evt.key === ' '
        ) {
          this.pass();
        }
      },

      pass() {
        if (this.passed) {
          // user already passed, now they're continuing

          // reset the question before we continue; this ensures we haven't moved to the next question
          // before reset and accidentally mark the wrong question answered
          this.reset();

          EventBus.$emit('passed', this.question);
          return;
        }

        this.passed = true; // mark as answered even though we're passing
        this.swapState();
      },

      markCorrect(correct) {
        this.correct = correct || false;
        this.answered = true;

        // reset the question before we continue; this ensures we haven't moved to the next question
        // before reset and accidentally mark the wrong question answered
        this.reset();

        EventBus.$emit('answered', correct || false, this.question); // we reset, so this.correct changed already
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $blue: rgb(6, 12, 234);

  .question {
    cursor: pointer;

    h4 {
      font-size: 1.1rem;
      font-family: 'Markazi Text', serif;
      text-shadow: 2px 2px 2px #000000;
    }

    .buttons {
      width: 100%;
    }

    &.is-fullscreen {
      position: fixed;
      top: 0;
      left: 0;
      border: 0;
      width: 100%;
      height: 100%;
      z-index: 5;

      h4 {
        font-size: 2rem;
        font-weight: 800;
        padding: 40px 20%;

        @media print, screen and (min-width:769px) {
          font-size: 3rem;
        }
      }

      h5.meta {
        position: absolute;
        bottom: 5px;
        text-align: center;
        width: 100%;
        font-size: 1.2em;
        font-weight: 600;
      }
    }
  }

</style>
